<footer class="footer">
  <div class="footer__top">
    <div class="container">
      <div class="footer__top-row">
        <a href="#" class="footer__logo">
          <img ngSrc="/assets/images/logo.svg" alt="НДВ супермаркет недвижимости" width="95" height="48">
        </a>
        <div class="footer__city" (click)="openSelectCity()">
          <app-ui-icon [name]="'icon-local'" [width]="'16'"></app-ui-icon>
          <span>Москва</span>
        </div>
        <div class="w-full sm:hidden"></div>
        <a href="tel:+74951377489" class="footer__phone">+7 (495) 137-74-89</a>
        <div class="footer__copyright">© 2024
          <app-ui-icon [name]="'icon-telegram'" [width]="28" [height]="24"></app-ui-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="footer__bottom">
    <div class="container">
      <div class="footer__bottom-row">
        <nav class="footer__nav">
          <a href="#">О сервисе</a>
          <a href="#">Брокер-туры</a>
          <a href="#">Скидки и акции</a>
          <a href="#">База знаний</a>
          <a href="#">Застройщикам</a>
          <a href="#">Новости</a>
          <a href="#">Партнерам</a>
        </nav>
        <div class="footer__copytext">
          Использование сайта означает согласие с <a href="#">Информацией о «cookies»,
          «Пользовательским соглашением», Политикой обработки персональных данных</a>
        </div>
      </div>
    </div>
  </div>
</footer>
